import { render } from "./Trend.vue?vue&type=template&id=757aaa27"
import script from "./Trend.vue?vue&type=script&setup=true&lang=js"
export * from "./Trend.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/TableFields/Trend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "757aaa27"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('757aaa27', __exports__)) {
    api.reload('757aaa27', __exports__)
  }
  
  module.hot.accept("./Trend.vue?vue&type=template&id=757aaa27", () => {
    api.rerender('757aaa27', render)
  })

}


export default __exports__